import React from 'react'
import { NavLink } from 'react-router-dom'
import BaseComponent from './BaseComponent'
import _ from 'lodash'

export default class Header extends BaseComponent {

  constructor(props) {

    super(props)
    this.state = { nav: false, underWidth: 110, underX: 0, lastWidth: 110, lastX: 0  }
    this._bind('toggleNav', 'closeNav', 'setUnder', 'out')
  }

  toggleNav() {
    if ( this.state.nav ) {
      this.setState({ nav: false })
    } else {
      this.setState({ nav: true })
    }
  }

  closeNav(e) {
    this.setState({ nav: false, lastWidth: e.target.offsetWidth, underWidth: e.target.offsetWidth, lastX: e.target.offsetLeft, underX: e.target.offsetLeft })
  }

  setUnder(e) {
    this.setState({ underWidth: e.target.offsetWidth, underX: e.target.offsetLeft })
  }

  out() {
    this.setState({ underWidth: this.state.lastWidth, underX: this.state.lastX })
  }

  render() {

    let navItems = _.filter(this.props.data.nav, { position: "header" })[0].items

    let nav = navItems.map((item, i) => {
      return (
        <li key={ i }><NavLink to={ item.value } className="nav-item" activeClassName="active" onMouseOver={ this.setUnder } onMouseOut={ this.out } onClick={ this.closeNav }>{ item.title }</NavLink></li>
      )
    })

    return (
      <header className="header">
        <div className="container-big">
          <NavLink to="/"><img className="logo" src="/assets/img/logo.png" alt="Ekostar Logo" onClick={ this.closeNav }/></NavLink>
          <div className={ this.state.nav ? "burger open" : "burger" } onClick={ this.toggleNav }><span></span></div>
          <nav className={ this.state.nav ? "open" : "" }>
            <ul>
              { nav }
            </ul>
          </nav>
          <div className="under-holder">
            <div className="line"></div>
            <div className="underline" style={{ transform: "translateX(" + this.state.underX + "px)", width: this.state.underWidth }}></div>
          </div>
        </div>
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/Header.js